import { SettingsSection } from "./SettingsSection";
import { PageHeader } from "./page-header/PageHeader";
import { useBranding } from "@/hooks/useBranding";

export default function Dashboard() {
  useBranding();

  return (
    <div className="h-full flex flex-col">
      <PageHeader />
      <SettingsSection />
    </div>
  );
}

